import {
  Component,
  ElementRef,
  NgZone,
  OnInit,
  OnDestroy,
  ViewChild
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  AssigneeService,
  Batch,
  ClientQuestionService,
  ClientQuestionWithFilters,
  ClientService,
  ClientWithAllTaxReturns,
  Population,

  PopulationAssigneesInner,
  TaxReturnSubType,
  TaxReturnType,
  TaxReturnWithPreparerAndReviewer,
  SyncWithOneteamResponse,
  TaxReturnService
} from "../../../../swaggerServices";
import { ProcessStatePollingService } from "./../../../shared/services/process-state-polling.service";
import { initializeTaxReturn } from "../../tax-returns/get-full-tax-return";
import { IClient } from "../../sidebar/client-sidebar/client-sidebar.component";
import { ClientRouteResolver } from "../client/client-route-resolver.service";
import { Subscription } from "rxjs";
import { cloneDeep } from "lodash-es";
import { KeywordPipe } from "../../../shared/pipes/keyword.pipe";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { DropdownListOption } from "../../../shared/components/search-dropdown/search-dropdown.component";
import { Tenant } from "../../../shared/types/tenant.enum";
import { ConfigStateService } from "../../config/config-state.service";
import { TenantConfigService } from "../../../shared/services/tenant-config.service";
import { getQuestionnaireTypes } from "../../../shared/util/questionnaire-type.util";
import { TaxReturnTypeSubTypeService } from "../../../shared/util/tax-return-type-subtype.service";
import { BulkUpdateTaxReturnService } from "../../../shared/services/bulk-update-tax-return.service"
import { ITaxReturn } from "../../tax-returns/tax-return/model/i-tax-return";
import {TaxReturnAction, TaxReturnStatus, TaxReturnStep} from "../../tax-returns/tax-return/model/status";
import { GlobalConfig } from "../../config/config-states";
import { TaxReturnActionsComponent } from "../../../shared/components/tax-return-actions/tax-return-actions.component";
import { CurrentBatchService } from "../../../shared/services/current-batch.service";
import { BulkActionStatus } from "../../tax-returns/tax-return/model/bulk-action-status";
import { TranslocoService } from "@jsverse/transloco";
declare const $: any;
const numberPattern = /^\d+$/;

@Component({
    selector: "app-client-taxpayers",
    templateUrl: "./client-taxpayers.component.html",
    styleUrls: ["./client-taxpayers.component.scss"],
    standalone: false
})
export class ClientTaxpayersComponent implements OnInit, OnDestroy {
  client: IClient;
  taxYr: number;
  clientId = this.activatedRoute.queryParams["value"].clientId;
  assignees = [];
  filteredAssignees = [];
  isClientTaxreturnsPage = true;

  selectedTaxReturnTypeId = 0;
  selectedTaxReturnSubTypeId = 0;
  selectedPopulationId = 0;
  selectedBatchId = 0;

  baseTaxReturnTypeList: any[] = [];
  baseTaxReturnSubtypeList: any[] = [];
  basePopulationList: Population[] = [];

  taxReturnTypeById: { [id: string]: TaxReturnType } = {};
  taxReturnSubTypeById: { [id: string]: TaxReturnSubType } = {};
  populationById: { [id: string]: Population } = {};
  batchById: { [id: string]: Batch } = {};

  subscriptions: Subscription[] = [];
  searchText = "";

  taxReturnTypeDropdownObj: any;
  taxReturnSubTypeDropdownObj: any;
  populationDropdownObj: any;
  batchDropdownObj: any;

  taxReturnType: UntypedFormControl;
  taxReturnTypeOptions: DropdownListOption[];
  taxReturnTypeVals: any[];
  taxReturnSubTypeVals: any[];
  populationVals: any[];
  batchVals: any[];

  currentTaxReturnTypeList: TaxReturnType[] = [];
  currentTaxReturnSubTypelist: TaxReturnSubType[] = [];
  currentPopulationlist: Population[] = [];
  currentBatchList: Batch[] = [];

  showTaxReturnType = true;
  filterQuestions = [];
  IsFilterQuestionsVisible = false;
  filterQuestionsForm: UntypedFormGroup = new UntypedFormGroup({});
  customFilterAnswers: string[] = [];
  populationIdsToFilter = [];
  placeholder = "Select...";
  uiConfig: TenantConfigService;
  tenants: any;
  showQnrType: boolean;
  isEssTenant = false;
  taxIdVariable: string;
  qnrTypeOptions: DropdownListOption[];
  taxId: UntypedFormControl;
  bulkAddAssignee: any;
  taxReturnTypeCtrl: UntypedFormControl;
  firstName: UntypedFormControl;
  lastName: UntypedFormControl;
  atlasId: UntypedFormControl;
  gtsId: UntypedFormControl;
  actionsView: boolean = false;
  actionList: string[] = [];
  taxReturnAlias: string;
  taxpayerAlias: string;
  atlasIdVariable: string;
  entityPrimaryName: string;
  entitySecondaryName: string;
  actionListOfTaxReturns: {[actionString:string]: {actions:TaxReturnAction[], taxReturns: ITaxReturn[], statuses: TaxReturnStatus[], disabled?: boolean }} = {};
  actionStringByTaxReturnId: {[taxReturnId: number]: string} = {};
  actionResults: {[taxReturnId: number]:  BulkActionStatus} = {};
  bulkActionInProgress: boolean = false;
  populationAlias: string;
  AuthlistName: string;
  oneteamSyncResponse: SyncWithOneteamResponse = {message: "", errorMessages:[]};
  syncingWithOneTeam: boolean = false;
  //isUpdateToDateWithOneTeam : boolean = true;
  lang: string

  @ViewChild("taxReturnTypeDropdown") taxReturnTypeDropdown: ElementRef;
  @ViewChild("taxReturnSubTypeDropdown") taxReturnSubTypeDropdown: ElementRef;
  @ViewChild("populationDropdown") populationDropdown: ElementRef;
  @ViewChild("batchDropdown") batchDropdown: ElementRef;
  @ViewChild(TaxReturnActionsComponent) taxReturnActionsComponent: TaxReturnActionsComponent;
  @ViewChild('oneteamSyncModal') oneteamSyncModal: ElementRef;

  constructor(
    private activatedRoute: ActivatedRoute,
    private clientService: ClientService,
    private clientQuestionService: ClientQuestionService,
    private clientRouteResolver: ClientRouteResolver,
    public config: ConfigStateService,
    private bulkUpdateTaxReturnService: BulkUpdateTaxReturnService,
    private currentBatchService: CurrentBatchService,
    private translocoService: TranslocoService,
    private ProcessStatePollingService: ProcessStatePollingService,
    private taxReturnService: TaxReturnService,
  ) {
    translocoService.langChanges$.subscribe(l => this.lang = l);
  }

  ngOnInit() {
    this.tenants = Tenant;
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.isEssTenant = this.config.tenant === Tenant.ESS;
        this.showQnrType = this.config.tenant === Tenant.AU;
        this.taxIdVariable = this.uiConfig.config.taxId;
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias;
        this.taxpayerAlias = this.uiConfig.config.taxpayerAlias;
        this.atlasIdVariable = this.uiConfig.config.atlasId;
        this.entityPrimaryName = this.uiConfig.config.entityPrimaryName;
        this.entitySecondaryName = this.uiConfig.config.entitySecondaryName;
        this.populationAlias = this.uiConfig.config.populationAlias
        this.AuthlistName = this.config.featureFlags.replaceAuthlistNameToEntityList? "Entity List": "Auth List";
        if (this.showQnrType) {
          this.qnrTypeOptions = getQuestionnaireTypes();
        }
        if (this.config.tenant === Tenant.SG) {
          this.taxId.setValidators(Validators.required);
        }
      })
    );
    this.subscriptions.push(
      this.clientRouteResolver.client().subscribe((client: any) => {
        this.client = client;
      })
    );
    this.subscriptions.push(
      this.activatedRoute.queryParams.subscribe(params => {
        if (params.taxYear) {
          this.taxYr = params.taxYear;
          this.refresh();
        }
      })
    );
    this.subscriptions.push(
      this.bulkUpdateTaxReturnService.actionsView.subscribe(actionsView => {
        this.actionsView = actionsView;
        if(actionsView === false){
          this.bulkActionInProgress = false;
          this.actionListOfTaxReturns = {}
          this.actionResults = {}
        }
      })
    );
    this.subscriptions.push(
      this.bulkUpdateTaxReturnService.selectedTaxReturns.subscribe(selectedTaxReturns => {
        // reset the actionList
        this.actionListOfTaxReturns = {};
        // sort the tax returns into groups of similar actions
        selectedTaxReturns.forEach(tr => {
          if (tr.taxReturnTypeKey === 'Taxpayer') return;
          const currentStatus = TaxReturnStatus.byId(tr.status, GlobalConfig.tenant)
          const actions = currentStatus.actions(GlobalConfig)
          let actionString = ''
          actions.forEach(action => {
            actionString = actionString === '' ? action.id : `${actionString}_${action.id}`
          })
          this.actionStringByTaxReturnId[tr.id] = actionString;
          if(!this.actionListOfTaxReturns[actionString]){
            this.actionListOfTaxReturns[actionString] = {actions, taxReturns:[], statuses:[]};
          }
          this.actionListOfTaxReturns[actionString].taxReturns.push(tr);
          if(!this.actionListOfTaxReturns[actionString].statuses.some((status: TaxReturnStatus) => status.id === currentStatus.id)){
            this.actionListOfTaxReturns[actionString].statuses.push(currentStatus)
          }
        })
        this.actionList = Object.keys(this.actionListOfTaxReturns)
      })
    );
  }

  ngOnDestroy() {
    this.bulkUpdateTaxReturnService.setTaxReturnList([]);
    this.bulkUpdateTaxReturnService.setActionViewFlag(false);
    this.subscriptions.forEach(s => s.unsubscribe());
    this.currentBatchService.changeBatch({});
  }


  updateCurrentBatchObservable(){
    const currentBatch = this.currentBatchList.find(b => b.id === this.selectedBatchId);
    // if(currentBatch){
      this.currentBatchService.changeBatch(currentBatch)
    // }
  }

  applyFilterQuestion(event) {
    const populationIds = [];

    if ( this.selectedPopulationId && this.selectedPopulationId !== 0 ) {
      populationIds.push([this.selectedPopulationId]);
    }
    this.populationIdsToFilter = [];
    this.filterQuestions.forEach(questionAnswerObject => {
      const questionId = questionAnswerObject.question.id;
      const populationId =
        this.filterQuestionsForm &&
        this.filterQuestionsForm.get(questionId.toString())
          ? this.filterQuestionsForm.get(questionId.toString()).value
            .populationIds
          : null;

      if (populationId) {
        populationIds.push(populationId);
      } else {
        const selectedValue = this.filterQuestionsForm.get(
          questionId.toString()
        ).value.value;

        if (selectedValue === "BLANK") {
          const question = this.filterQuestions.find(
            q => q["question"].id === questionId
          );
          populationIds.push(question["unAnsweredPopulationIds"]);
        }
      }
    });


    if (populationIds && populationIds.length) {
      const populationIdIntersection = populationIds.reduce((a, c) =>
        a.filter(i => c.includes(i))
      );


      if (populationIdIntersection.length) {
        this.populationIdsToFilter = populationIdIntersection;
      } else {
        this.populationIdsToFilter = [0];
      }
    }

    this.filterTaxReturn();
    this.resetCustomFilters();
    this.updateCurrentBatchObservable()
  }
  getFormControl(id: number) {
    if (
      id &&
      this.filterQuestionsForm &&
      this.filterQuestionsForm.get(id.toString())
    ) {
      return this.filterQuestionsForm.get(id.toString());
    } else {
      return null;
    }
  }
  getTaxReturns() {
    this.IsFilterQuestionsVisible = false;
    const year = this.taxYr ? this.taxYr : 0;

    this.clientService
      .getAllTaxreturnsByClientId(year, this.clientId)
      .subscribe((result: ClientWithAllTaxReturns) => {
        this.assignees = result.assignees;
        this.currentBatchList = result.batches;
        this.currentBatchService.cacheClientBatches(this.clientId, result.batches);

        if ( result.populations && result.populations.length ) {
          this.basePopulationList = result.populations;
          this.basePopulationList.forEach(pp => {
            this.populationById[pp.id] = pp;
          });
        }

        if (result.taxReturnTypes && result.taxReturnTypes.length) {
          this.baseTaxReturnTypeList = result.taxReturnTypes;
          this.baseTaxReturnTypeList.forEach(tt => {
            this.taxReturnTypeById[tt.id] = tt;
          });
        }
        if (result.taxReturnSubTypes && result.taxReturnSubTypes.length) {
          this.baseTaxReturnSubtypeList = result.taxReturnSubTypes;
          this.baseTaxReturnSubtypeList.forEach(tst => {
            this.taxReturnSubTypeById[tst.id] = tst;
          });
        }

        this.showTaxReturnType =
          result.taxReturnSubTypes &&
          result.taxReturnSubTypes.length > 1 &&
          (result.taxReturnSubTypes && result.taxReturnSubTypes.length > 1);
        this.assignees.forEach(assignee =>
          assignee.taxReturns.forEach((taxReturn: any) => {
            if (taxReturn.taxReturnTypeId) {
              const found = this.baseTaxReturnTypeList.find(
                t => t.id === taxReturn.taxReturnTypeId
              );
              if (found) {
                taxReturn.taxReturnTypeName = found.type;
                taxReturn.taxReturnTypeKey = found.alias;
              }
            }
            if (taxReturn.taxReturnSubTypeId) {
              const found = this.baseTaxReturnSubtypeList.find(
                t => t.id === taxReturn.taxReturnSubTypeId
              );
              if (found) {
                taxReturn.taxReturnSubTypeName = found.subType;
              }
            }
            // if (taxReturn.syncStatus && taxReturn.syncStatus>0)
            // {
            //   this.isUpdateToDateWithOneTeam=false;
            // }
            initializeTaxReturn(taxReturn);
          })
        );

        this.assignees.forEach(assignee => {
          assignee.populations = result.populations;
        });

        this.searchText = "";
        this.selectedTaxReturnTypeId = 0;
        this.selectedTaxReturnSubTypeId = 0;
        this.updateFilteredAssignees();
        this.populateFilters();
      });

    this.clientQuestionService
      .getAllFilterQuestionsByYear(year, this.clientId)
      .subscribe((result: ClientQuestionWithFilters) => {
        this.filterQuestions = result.clientQuestions;
        this.filterQuestions.forEach(filterQuestionObj => {
          const allPopulationIds = filterQuestionObj.populationIds;
          const answeredPopulationIds = filterQuestionObj.answeredPopulationIds;
          const unAnsweredPopulationIds = allPopulationIds.filter(
            f => !answeredPopulationIds.includes(f)
          );
          filterQuestionObj["unAnsweredPopulationIds"] =
            answeredPopulationIds && answeredPopulationIds.length
              ? unAnsweredPopulationIds
              : allPopulationIds;
          filterQuestionObj["unicodeIcon"] =
            answeredPopulationIds.length && unAnsweredPopulationIds.length
              ? "&#x26A0;"
              : "";
          const firstValue = { value: 0, name: "All" };
          const blankValue = { value: "BLANK", name: "[BLANK]" };

          const answerObject = filterQuestionObj.answers.map(tt => {
            return {
              value: tt.id,
              name: tt.answer,
              populationId: tt.populationId,
              populationIds: tt.populationIds
              // selected:
            };
          });

          if (unAnsweredPopulationIds.length) {
            filterQuestionObj.answers = [
              firstValue,
              blankValue,
              ...answerObject
            ];
          } else {
            filterQuestionObj.answers = [firstValue, ...answerObject];
          }

          this.filterQuestionsForm.addControl(
            filterQuestionObj.question.id,
            new UntypedFormControl("")
          );
          this.taxReturnTypeVals = [{ value: 0, name: "All" }];
        });
      });
  }
  refresh() {
    this.getTaxReturns();
    this.resetFilter();
  }
  resetFilter() {
    this.searchText = "";
    this.selectedTaxReturnTypeId = 0;
    this.selectedTaxReturnSubTypeId = 0;
    this.populationIdsToFilter = [];
    this.updateFilteredAssignees();
  }
  resetCustomFilters() {
    const controls = Object.values(this.filterQuestionsForm.controls)
    const names = controls.map(form => form.value.name)
    this.customFilterAnswers = names
  }
  updateFilteredAssignees() {
    if (!this.assignees) {
      this.filteredAssignees = [];
    } else {
      const assignees: Array<PopulationAssigneesInner> = this.assignees || [];
      // create an array of "search data" containing flattened out tax returns, this lets us search
      // over the N tax returns of an assignee
      const searchData = [];
      assignees.forEach(assignee => {
        if (assignee.taxReturns.length === 0) {
          searchData.push({
            assigneeId: assignee.id,
            firstName: assignee.firstName,
            lastName: assignee.lastName,
            atlasId: assignee.atlasId
          });
        } else {
          assignee.taxReturns.forEach(taxReturn => {
            searchData.push({
              assigneeId: assignee.id,
              firstName: taxReturn.firstName,
              lastName: taxReturn.lastName,
              atlasId: taxReturn.atlasId
            });
          });
        }
      });

      // now do the pipe filter
      const filteredData =
        new KeywordPipe().transform(
          searchData,
          ["firstName", "lastName", "atlasId"],
          this.searchText,
          true
        ) || [];

      // prepare the tax return types/subtypes
      this.baseTaxReturnTypeList.forEach(tt => {
        this.taxReturnTypeById[tt.id] = tt;
      });
      this.baseTaxReturnSubtypeList.forEach(tst => {
        this.taxReturnSubTypeById[tst.id] = tst;
      });

      // finally convert the filtered data back to assignees
      const assigneeIds = new Set(filteredData.map(d => d.assigneeId));
      this.filteredAssignees = assignees.filter(assignee => {
        const taxReturnList = assignee.taxReturns.filter(t => {
          return t.taxReturnTypeId === this.selectedTaxReturnTypeId;
        });
        return assigneeIds.has(assignee.id);
      });
      this.filteredAssignees.forEach(a => {
        a.taxReturns.forEach(t => {
          t.taxReturnTypeName =
            this.taxReturnTypeById[t.taxReturnTypeId].type || "";
          t.taxReturnSubTypeName =
            this.taxReturnSubTypeById[t.taxReturnSubTypeId].subType || "";
        });
      });
      this.filterTaxReturn();
    }
    this.resetCustomFilters()
    this.updateCurrentBatchObservable()
  }
  populateFilters() {
    this.filteredAssignees.forEach(a =>
      a.taxReturns.forEach(t => {
        if (
          this.currentTaxReturnTypeList &&
          (this.currentTaxReturnTypeList.length === 0 ||
            !this.currentTaxReturnTypeList.some(
              (tt: TaxReturnType) => tt.id === t.taxReturnTypeId
            ))
        ) {
          this.currentTaxReturnTypeList = [
            ...this.currentTaxReturnTypeList,
            this.taxReturnTypeById[t.taxReturnTypeId]
          ];
        }
        if (
          this.currentTaxReturnSubTypelist &&
          (this.currentTaxReturnSubTypelist.length === 0 ||
            !this.currentTaxReturnSubTypelist.some(
              (tt: TaxReturnSubType) => tt.id === t.taxReturnSubTypeId
            ))
        ) {
          this.currentTaxReturnSubTypelist = [
            ...this.currentTaxReturnSubTypelist,
            this.taxReturnSubTypeById[t.taxReturnSubTypeId]
          ];
        }
        if (
          this.currentPopulationlist &&
          (this.currentPopulationlist.length === 0 ||
            !this.currentPopulationlist.some(
              (pp: Population) => pp.id === t.populationId
            ))
        ) {
          this.currentPopulationlist = this.basePopulationList;
        }
      })
    );

    setTimeout(() => {
      this.populateTaxReturnTypesDropdown();
      this.populateTaxReturnSubTypesDropdown();
      this.populatePopulationDropdown();
      this.populateBatchDropdown();
    }, 100);
  }
  populateTaxReturnTypesDropdown() {
    if (this.currentTaxReturnTypeList && this.currentTaxReturnTypeList.length) {
      this.taxReturnTypeVals = [{ value: 0, name: "All" }];
      this.taxReturnTypeVals = [
        ...this.taxReturnTypeVals,
        ...this.currentTaxReturnTypeList.map(tt => {
          return {
            value: tt.id,
            name: tt.type
            // selected:
          };
        })
      ];
      if (
        this.taxReturnTypeDropdown &&
        this.taxReturnTypeDropdown.nativeElement
      ) {
        this.taxReturnTypeDropdownObj = $(
          this.taxReturnTypeDropdown.nativeElement
        ).dropdown({
          values: this.taxReturnTypeVals,
          placeholder: "Select...",
          fullTextSearch: "exact",
          preserveHTML: false,
          onChange: (value: string) => {
            if (value) {
              this.selectedTaxReturnTypeId = +value;
              this.filterTaxReturn();
            }
          }
        });
      }
    }
  }
  populateTaxReturnSubTypesDropdown() {
    if (
      this.currentTaxReturnSubTypelist &&
      this.currentTaxReturnSubTypelist.length
    ) {
      this.taxReturnSubTypeVals = [{ value: 0, name: "All" }];
      this.taxReturnSubTypeVals = [
        ...this.taxReturnSubTypeVals,
        ...this.currentTaxReturnSubTypelist.map(tt => {
          return {
            value: tt.id,
            name: tt.subType
            // selected:
          };
        })
      ];
      if (
        this.taxReturnSubTypeDropdown &&
        this.taxReturnSubTypeDropdown.nativeElement
      ) {
        this.taxReturnSubTypeDropdownObj = $(
          this.taxReturnSubTypeDropdown.nativeElement
        ).dropdown({
          values: this.taxReturnSubTypeVals,
          placeholder: "Select...",
          fullTextSearch: "exact",
          preserveHTML: false,
          onChange: (value: string) => {
            if (value) {
              this.selectedTaxReturnSubTypeId = +value;
              this.filterTaxReturn();
            }
          }
        });
      }
    }
  }
  populatePopulationDropdown() {
    if (
      this.currentPopulationlist &&
      this.currentPopulationlist.length
    ) {
      this.populationVals = [{ value: 0, name: "All" }];
      this.populationVals = [
        ...this.populationVals,
        ...this.currentPopulationlist.map(tt => {
          return {
            value: tt.id,
            name: tt.name
            // selected:
          };
        })
      ];
      if (
        this.populationDropdown &&
        this.populationDropdown.nativeElement
      ) {
        this.populationDropdownObj = $(
          this.populationDropdown.nativeElement
        ).dropdown({
          values: this.populationVals,
          placeholder: "Select...",
          fullTextSearch: "exact",
          preserveHTML: false,
          onChange: (value: string) => {
            if (value) {
              this.selectedPopulationId = +value;
              this.applyFilterQuestion(value);
            }
          }
        });
      }
    }
  }
  populateBatchDropdown() {
    if (
      this.currentBatchList &&
      this.currentBatchList.length
    ) {
      const sorted = [...this.currentBatchList].sort((a,b) => a.name.localeCompare(b.name));
      this.batchVals = [{ value: 0, name: "All" },{ value: -1, name: "Unbatched" }];
      this.batchVals = [
        ...this.batchVals,
        ...sorted
        .map(tt => {
          return {
            value: tt.id,
            name: tt.name
            // selected:
          };
        })
      ];
      if (
        this.batchDropdown &&
        this.batchDropdown.nativeElement
      ) {
        this.batchDropdownObj = $(
          this.batchDropdown.nativeElement
        ).dropdown({
          values: this.batchVals,
          placeholder: "Select...",
          fullTextSearch: "exact",
          preserveHTML: false,
          onChange: (value: string) => {
            if (value) {
              this.selectedBatchId = +value;
              this.applyFilterQuestion(value);
            }
          }
        });
      }
    }
  }
    filterTaxReturn() {
    const clonedAssignees = cloneDeep(this.assignees);
    this.filteredAssignees = clonedAssignees.filter(
      (a: PopulationAssigneesInner) => {
        const searchText =
          !this.searchText ||
          (a.firstName.toLowerCase().includes(this.searchText.toLowerCase()) ||
            a.lastName.toLowerCase().includes(this.searchText.toLowerCase()) ||
            a.atlasId
              .toString()
              .toLowerCase()
              .includes(this.searchText.toLowerCase()));

        if (a.taxReturns && a.taxReturns.length && searchText) {
          a.taxReturns = a.taxReturns.filter(
            (tr: TaxReturnWithPreparerAndReviewer) => {
              // Filter By either taxReturnType, taxReturnSubType, populationId or batchId
              let condition = true;

              if(this.selectedTaxReturnTypeId){
                condition = condition && tr.taxReturnTypeId === this.selectedTaxReturnTypeId
              }
              if(this.selectedTaxReturnSubTypeId){
                condition = condition && tr.taxReturnSubTypeId === this.selectedTaxReturnSubTypeId
              }
              if(this.selectedBatchId){
                if(this.selectedBatchId < 0){
                  condition = condition && tr.batchId == null
                } else {
                    condition = condition && tr["batches"]?.some(batch => batch.batchId === this.selectedBatchId);
                }
              }
              if(this.populationIdsToFilter.length){
                const hasPopulationMatch = this.populationIdsToFilter.some(p => tr.populationId === p);
                condition = condition && hasPopulationMatch;
              }
              return condition;
            }
          );

          return a.taxReturns && a.taxReturns.length;
        }
      }
    );
  }
  backToList(){
    this.bulkUpdateTaxReturnService.setActionViewFlag(false);
  }
  doBulkAction(action: TaxReturnAction, listOfTaxReturns){
    this.taxReturnActionsComponent.doBulkAction(listOfTaxReturns, action)
  }

  handleDisableActions(actionGroup){
    // disable actions for the current actionstring
    this.actionListOfTaxReturns[actionGroup].disabled = true;
  }
  handleSingleBulkResponse(bulkEventResponse: BulkActionStatus){
    this.actionResults[bulkEventResponse.taxReturnId] = bulkEventResponse;
    if(bulkEventResponse.status === 'pending'){
      this.bulkActionInProgress = true;
      this.actionListOfTaxReturns[this.actionStringByTaxReturnId[bulkEventResponse.taxReturnId]].disabled = true
    } else {
      this.bulkActionInProgress = Object.values(this.actionResults).some((result:BulkActionStatus) => result.status === 'pending')
    }

  }
  getActionResultString(bulkEventResponse: BulkActionStatus){
    // action has not returned yet
    if(!bulkEventResponse){
      return '';
    }
    let result = ''
    if(bulkEventResponse.message){
      result = bulkEventResponse.message;
    }
    return result;
  }
  getActionResultPending(bulkEventResponse: BulkActionStatus){
    // action has not returned yet
    if(!bulkEventResponse){
      return false;
    }
    if(bulkEventResponse.status === "pending"){
      return true;
    }
    return false;
  }
  getActionResultSuccess(bulkEventResponse: BulkActionStatus){
    // action has not returned yet
    if(!bulkEventResponse){
      return false;
    }
    if(bulkEventResponse.success){
      return true;
    }
    return false;
  }

  getActionResultFail(bulkEventResponse: BulkActionStatus){
    // action has not returned yet
    if(!bulkEventResponse){
      return false;
    }
    if(bulkEventResponse.success === false){
      return true;
    }
    return false;
  }

  canSyncToOneteam() {
    return this.config.featureFlags.enableOneteamIntegration
  }

  syncToOneteam() {
      this.syncingWithOneTeam = true;
      this.clientService.clientSyncWithOneteamPost({id: this.clientId, year: this.taxYr, batchId: this.selectedBatchId}).subscribe(
        data => {
          this.syncingWithOneTeam = false;
          if(data?.success){
            this.oneteamSyncResponse.success = data?.success;
            this.oneteamSyncResponse.message = `Successfully synced client and its projects with Collaborate.`;
          } else {
            this.oneteamSyncResponse.errorMessages = data?.errorMessages || [];
          }
          $(this.oneteamSyncModal.nativeElement).modal("show");
        },
      err => {
          this.syncingWithOneTeam = false;
        if(err.error.errorMessages?.length){
          this.oneteamSyncResponse.errorMessages = err?.error?.errorMessages || `Failed to sync client and its projects with Collaborate.`;
          $(this.oneteamSyncModal.nativeElement).modal("show");
        }
      });
  }

  closeOneteamSyncModal(){
    this.oneteamSyncResponse.message = "";
    this.oneteamSyncResponse.errorMessages = [];
    $(this.oneteamSyncModal.nativeElement).modal("hide");
  }

  canDownloadAuthlist() {
    return this.config.featureFlags.downloadAuthlist
  }

  downloadAuthlist() {
    const authlistData = []
    this.assignees.map(assignee => {
      assignee.taxReturns.map(taxReturn => {
        let data = {
          entityName: taxReturn.firstName,
          entityId: taxReturn.atlasId,
          population: assignee.populations.find(p => p.id === taxReturn.populationId).name,
          taxReturnType: taxReturn.taxReturnTypeName,
          taxReturnSubType: taxReturn.taxReturnSubTypeName
        }
        authlistData.push(data)

      })
    })

    const headers = Object.keys(authlistData[0])
    const refinedData = []
    refinedData.push(headers)
    authlistData.forEach(item => {
      refinedData.push(Object.values(item))
    })

    let csvContent = ''
    refinedData.forEach(row => {
      csvContent += row.join(',') + '\n'
    })

    // save csv file
    var elem = window.document.createElement('a');
    const blob = new Blob(
      [
        new Uint8Array([0xEF, 0xBB, 0xBF]), // UTF-8 BOM
        csvContent
      ],
      { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    elem.href = url
    elem.download = `${this.client.name}-${this.AuthlistName}`
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }
}
